import { Card, CardContent } from "./ui/card";
import { Calendar, BarChart3, PenTool } from "lucide-react";

export function HowTo() {
  const steps = [
    {
      number: "1",
      icon: PenTool,
      title: "Record Decision",
      description: "Capture your decision with context, rationale, and an initial confidence rating.",
      example: 'Decision #1: Decided to try Decisionr today. Rating: 8/10 - "Excited to improve my decision-making process."'
    },
    {
      number: "2", 
      icon: Calendar,
      title: "Review & Rate",
      description: "Revisit your decision at future dates and update your ratings with new insights.",
      example: 'Decision #1 rating at day 7: 9/10 - "Have been learning a lot from getting into the habit of capturing decision making."'
    },
    {
      number: "3",
      icon: BarChart3,
      title: "Analyze Patterns",
      description: "Discover trends in your decision-making by tags, categories, and rating changes over time.",
      example: 'Insight: "Decisions tagged with \'work\' tend to start with low confidence but average +2 points by the 30-day review."'
    }
  ];

  return (
    <section className="py-16 bg-muted/60">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">How It Works</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Transform your decision-making with our simple three-step process
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card key={index} className="relative overflow-hidden">
                <CardContent className="p-6">
                  {/* Step number badge */}
                  <div className="absolute -top-2 -right-2 w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                    <span className="text-primary font-bold text-lg">{step.number}</span>
                  </div>
                  
                  {/* Icon */}
                  <div className="mb-4">
                    <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                  <p className="text-muted-foreground mb-4">{step.description}</p>
                  
                  {/* Example */}
                  <div className="bg-muted/50 rounded-lg p-3 border-l-4 border-primary/30">
                    <p className="text-sm italic text-muted-foreground">{step.example}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}